var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSafeDelivery = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.47 6.558c-.085-.4-.222-1.193-1.04-1.193h-2.012l.133-.924c.13-.668-.39-.941-.908-.941L.714 3.503l.31 1.862h8.297l-.25.929H1.18l.31 1.856H6.54l-.254.922H1.643l.31 1.865 1.364-.003-.715 2.604c-.139.496.008 1.105.517 1.105h.394c.214 1.06 1.183 1.857 2.306 1.857 1.124 0 2.11-.797 2.324-1.857h4.643c.215 1.056 1.198 1.852 2.318 1.852s2.108-.796 2.324-1.852h.426c.396 0 .734-.325.804-.772l.627-3.864-.816-3.447.002-.002Z",
  fill: "url(#safe_delivery_svg__a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.43 6.294h-2.173l-.613 3.714h3.724l-.938-3.714ZM15.107 15.571a1.393 1.393 0 1 1 0-2.786 1.393 1.393 0 0 1 0 2.786ZM5.822 15.571a1.393 1.393 0 1 1 0-2.786 1.393 1.393 0 0 1 0 2.786Z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "safe_delivery_svg__a",
  x1: 0.714,
  y1: 3.5,
  x2: 19.28,
  y2: 16.507,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#63CE05"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#225CBE"
})))));
export default SvgSafeDelivery;